<div class="row">
  <ng-container *ngIf="field_students">
    <div
      *ngFor="let student of field_students; let i = index;"
      class="attendee-card mat-elevation-z1"
    >
      <div class="attendee-main">
        <!-- Use _displayName (individual contact name) when available, falling back
             to field_student_account. _displayName is set by base-form (for API-loaded
             attendees) and studentIncrement (for newly added attendees) to show the
             individual contact name instead of the combined student account title. -->
        <div class="attendee-name">
          {{ student._displayName || student.field_student_account }}
        </div>
      </div>
      <div class="attendee-actions" *ngIf="!editMode">
        <mat-icon class="attendee-icon edit" aria-label="edit attendee" (click)="studentUpdateLoad(i, attendee)">edit</mat-icon>
        <mat-icon class="attendee-icon remove" aria-label="remove attendee" (click)="studentRemove(i)">cancel</mat-icon>
      </div>
    </div>
  </ng-container>
</div>
